import { useEffect, useState } from "react";
import Accordion from 'react-bootstrap/Accordion';
import Footer from "../Footer";
import Head from "../Head";

const FrequentlyAskedQuestions = () => {
    useEffect(() => {
        window.scrollTo(0, 0)
    }, [])
    const allKeys = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11'];
    const [activeKey, setActiveKey] = useState(allKeys); 
    return (
        <><div className="top-head-section-new"></div>
            <div className="faq-section">

                <div className="container">
                    <div className="modified-header"> <Head /></div>
                    <div className="faq_content_bx">
                        <h2 className="title_faq">Frequently Asked Questions</h2>
                        <Accordion activeKey={activeKey} onSelect={(key) => {
                            if (activeKey.includes(key)) {
                                setActiveKey(activeKey.filter(k => k !== key)); 
                            } else {
                                setActiveKey([...activeKey, key]); 
                            }
                        }}>

                            <Accordion.Item eventKey="0">
                                <Accordion.Header>What is LFCoin?</Accordion.Header>
                                <Accordion.Body>
                                    LFCoin is a basketball-themed meme coin built on the Solana blockchain, designed to connect Laker fans and crypto enthusiasts through a unique and engaging platform.
                                </Accordion.Body>
                            </Accordion.Item>
                            <Accordion.Item eventKey="1">
                                <Accordion.Header>What is the purpose of LFCoin?</Accordion.Header>
                                <Accordion.Body>
                                    The coin seeks to unite Laker fans, known as the “LA Loyalists,” by providing a platform for community engagement, exclusive rewards, and live basketball experiences.
                                </Accordion.Body>
                            </Accordion.Item>
                            <Accordion.Item eventKey="2">
                                <Accordion.Header>Why is LFCoin built on the Solana blockchain?</Accordion.Header>
                                <Accordion.Body>
                                    Solana offers fast transactions, low fees, and scalability, making it an ideal choice for LFCoin’s goal of creating a seamless and accessible platform for its users.
                                </Accordion.Body>
                            </Accordion.Item>
                            <Accordion.Item eventKey="3">
                                <Accordion.Header>How can I buy LFCoin?</Accordion.Header>
                                <Accordion.Body>
                                    You can purchase LFCoin on Solana-based decentralized exchanges using a compatible wallet and Solana tokens.
                                </Accordion.Body>
                            </Accordion.Item>
                            <Accordion.Item eventKey="4">
                                <Accordion.Header>What makes LFCoin unique?</Accordion.Header>
                                <Accordion.Body>
                                    LFCoin combines the passion for the Lakers with innovative cryptocurrency utilities like live game updates, breaking news, and plans for interactive features like podcasts and chats.
                                </Accordion.Body>
                            </Accordion.Item>
                            <Accordion.Item eventKey="5">
                                <Accordion.Header>Who are the LA Loyalists?</Accordion.Header>
                                <Accordion.Body>
                                    The LA Loyalists are Laker fans who support LFCoin and participate in its growing community, celebrating their team while engaging with exclusive content and rewards.
                                </Accordion.Body>
                            </Accordion.Item>
                            <Accordion.Item eventKey="6">
                                <Accordion.Header>What are the utilities of LFCoin?</Accordion.Header>
                                <Accordion.Body>
                                    The LFCoin website features live Laker game updates, breaking news, and will soon include podcast streaming and chat features for fans to connect during and after games.
                                </Accordion.Body>
                            </Accordion.Item>
                            <Accordion.Item eventKey="7">
                                <Accordion.Header>Does LFCoin have a roadmap or white paper?</Accordion.Header>
                                <Accordion.Body>
                                    Yes, LFCoin has a detailed roadmap and white paper outlining its goals, development plans, and the future of its community-focused platform.
                                </Accordion.Body>
                            </Accordion.Item>
                            <Accordion.Item eventKey="8">
                                <Accordion.Header>Is LFCoin secure?</Accordion.Header>
                                <Accordion.Body>
                                    LFCoin operates on the secure Solana blockchain. To ensure safety, always use trusted wallets and exchanges.
                                </Accordion.Body>
                            </Accordion.Item>
                            <Accordion.Item eventKey="9">
                                <Accordion.Header>Will there be NFTs, collectibles, or merchandise associated with LFCoin?</Accordion.Header>
                                <Accordion.Body>
                                    Yes, LFCoin plans to release exclusive Laker-themed NFTs, digital collectibles, and merchandise available only on its official website.
                                </Accordion.Body>
                            </Accordion.Item>
                            <Accordion.Item eventKey="10">
                                <Accordion.Header>Where can I find LFCoin’s official social media platforms?</Accordion.Header>
                                <Accordion.Body>
                                    All official social media platforms are listed on the LFCoin website for verification and easy access.
                                </Accordion.Body>
                            </Accordion.Item>
                            <Accordion.Item eventKey="11">
                                <Accordion.Header>Is there a maximum supply of LFCoin?</Accordion.Header>
                                <Accordion.Body>
                                    Yes, there is a maximum supply of LFCoin, which is detailed in the white paper.
                                </Accordion.Body>
                            </Accordion.Item>
                        </Accordion>
                    </div>

                </div>
            </div>

            <div className="row">
                <div className="col-lg-12 col-md-12 col-sm-12 community-disclosur">
                    <div className="lend-cont-inner-in container">
                        <p>
                            <strong>Disclosure: </strong>
                            LF Coin ($LAL) is a community-driven meme coin created to
                            celebrate sports fandom and foster community engagement.
                            LF Coin is not affiliated with the Los Angeles Lakers, the
                            National Basketball Association (NBA), or any associated
                            organizations. The project operates independently and is
                            solely focused on building a decentralized community of
                            sports enthusiasts. As a meme coin, LF Coin carries no
                            intrinsic value and should not be considered an investment
                            or security.
                        </p>
                    </div>
                </div>
            </div>
            <div className="about-footer">
                <Footer />
            </div>
        </>
    );
}

export default FrequentlyAskedQuestions;